function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGooglePlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "646px",
    height: "193px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M -0.5,-0.5 C 214.833,-0.5 430.167,-0.5 645.5,-0.5C 645.5,63.8333 645.5,128.167 645.5,192.5C 430.167,192.5 214.833,192.5 -0.5,192.5C -0.5,128.167 -0.5,63.8333 -0.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#020202",
    d: "M 31.5,2.5 C 228.209,2.00459 424.876,2.50459 621.5,4C 629.667,6.83333 635.167,12.3333 638,20.5C 638.667,70.1667 638.667,119.833 638,169.5C 635.5,179.333 629.333,185.5 619.5,188C 422.833,188.667 226.167,188.667 29.5,188C 20.8946,185.062 15.3946,179.229 13,170.5C 12.3333,120.167 12.3333,69.8333 13,19.5C 16.1814,10.4815 22.3481,4.81485 31.5,2.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 139.5,32.5 C 140.5,32.5 141.5,32.5 142.5,32.5C 142.5,34.8333 142.5,37.1667 142.5,39.5C 139.188,51.1433 131.522,57.81 119.5,59.5C 119.61,45.6042 126.276,36.6042 139.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#828282",
    d: "M 337.5,33.5 C 337.5,43.8333 337.5,54.1667 337.5,64.5C 338.833,64.5 340.167,64.5 341.5,64.5C 341.5,54.1667 341.5,43.8333 341.5,33.5C 342.494,43.9869 342.828,54.6536 342.5,65.5C 340.5,65.5 338.5,65.5 336.5,65.5C 336.172,54.6536 336.506,43.9869 337.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fefefe",
    d: "M 337.5,33.5 C 338.833,33.5 340.167,33.5 341.5,33.5C 341.5,43.8333 341.5,54.1667 341.5,64.5C 340.167,64.5 338.833,64.5 337.5,64.5C 337.5,54.1667 337.5,43.8333 337.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f0f0",
    d: "M 416.5,33.5 C 418.167,33.5 419.833,33.5 421.5,33.5C 421.5,44.1667 421.5,54.8333 421.5,65.5C 420.167,65.5 418.833,65.5 417.5,65.5C 417.649,64.448 417.483,63.448 417,62.5C 407.677,68.0899 402.177,65.4232 400.5,54.5C 401.34,44.9139 406.34,41.5805 415.5,44.5C 416.489,40.8927 416.823,37.226 416.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#7e7e7e",
    d: "M 533.5,33.5 C 534.167,37.1667 534.833,40.8333 535.5,44.5C 535.44,45.0431 535.107,45.3764 534.5,45.5C 533.509,41.5546 533.176,37.5546 533.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f5f5",
    d: "M 227.5,35.5 C 233.161,35.5778 236.995,38.2445 239,43.5C 241.02,60.312 233.52,67.6454 216.5,65.5C 215.526,55.5824 215.193,45.5824 215.5,35.5C 219.5,35.5 223.5,35.5 227.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 139.5,32.5 C 140.568,31.5655 141.901,31.2322 143.5,31.5C 143.806,34.3854 143.473,37.0521 142.5,39.5C 142.5,37.1667 142.5,34.8333 142.5,32.5C 141.5,32.5 140.5,32.5 139.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b1b1b1",
    d: "M 227.5,35.5 C 223.5,35.5 219.5,35.5 215.5,35.5C 215.193,45.5824 215.526,55.5824 216.5,65.5C 214.525,55.5541 213.858,45.2208 214.5,34.5C 219.032,34.1818 223.366,34.5151 227.5,35.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#050505",
    d: "M 227.5,39.5 C 229.903,39.393 231.736,40.393 233,42.5C 237.259,54.6566 233.093,60.9899 220.5,61.5C 220.5,54.1667 220.5,46.8333 220.5,39.5C 222.833,39.5 225.167,39.5 227.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f5f5f5",
    d: "M 522.5,46.5 C 520.5,46.5 518.5,46.5 516.5,46.5C 516.182,51.0323 516.515,55.3656 517.5,59.5C 518.635,61.2132 520.302,61.8799 522.5,61.5C 522.5,62.8333 522.5,64.1667 522.5,65.5C 519.813,65.6641 517.146,65.4974 514.5,65C 513.418,63.6703 512.751,62.1703 512.5,60.5C 512.5,55.8333 512.5,51.1667 512.5,46.5C 511.5,46.5 510.5,46.5 509.5,46.5C 509.5,45.5 509.5,44.5 509.5,43.5C 510.5,43.5 511.5,43.5 512.5,43.5C 512.5,41.8333 512.5,40.1667 512.5,38.5C 513.833,38.5 515.167,38.5 516.5,38.5C 516.5,40.1667 516.5,41.8333 516.5,43.5C 518.5,43.5 520.5,43.5 522.5,43.5C 522.5,44.5 522.5,45.5 522.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#313131",
    d: "M 227.5,39.5 C 225.167,39.5 222.833,39.5 220.5,39.5C 220.5,46.8333 220.5,54.1667 220.5,61.5C 219.508,54.0182 219.175,46.3516 219.5,38.5C 222.385,38.1936 225.052,38.5269 227.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f3f3",
    d: "M 328.5,64.5 C 327.167,64.5 325.833,64.5 324.5,64.5C 324.819,59.6367 324.486,54.97 323.5,50.5C 323.315,48.1104 321.982,47.1104 319.5,47.5C 317.626,47.3898 316.126,48.0564 315,49.5C 314.501,54.8229 314.334,60.1563 314.5,65.5C 312.833,65.5 311.167,65.5 309.5,65.5C 309.5,58.1667 309.5,50.8333 309.5,43.5C 310.833,43.5 312.167,43.5 313.5,43.5C 313.443,47.1331 314.443,47.2998 316.5,44C 320.317,42.9766 323.817,43.4766 327,45.5C 328.416,51.7145 328.916,58.0478 328.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efeeef",
    d: "M 357.5,42.5 C 370.176,44.181 373.676,50.8476 368,62.5C 364.319,65.3597 360.152,66.1931 355.5,65C 352.572,63.7402 350.739,61.5735 350,58.5C 347.965,50.9068 350.465,45.5735 357.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f4f4f4",
    d: "M 393.5,49.5 C 393.5,54.5 393.5,59.5 393.5,64.5C 391.857,64.5198 390.524,63.8532 389.5,62.5C 388.893,62.6236 388.56,62.9569 388.5,63.5C 379.932,67.7731 376.099,65.1065 377,55.5C 380.387,51.9609 384.553,50.6276 389.5,51.5C 389.703,49.6096 389.037,48.1096 387.5,47C 384.77,46.2716 382.103,46.4383 379.5,47.5C 378.269,46.3493 378.269,45.1827 379.5,44C 383.167,43.3333 386.833,43.3333 390.5,44C 392.607,45.2635 393.607,47.0968 393.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f3f2f3",
    d: "M 470.5,43.5 C 471.833,43.5 473.167,43.5 474.5,43.5C 474.443,47.1331 475.443,47.2998 477.5,44C 481.244,43.0715 484.744,43.5715 488,45.5C 489.42,52.0496 489.92,58.7163 489.5,65.5C 487.833,65.5 486.167,65.5 484.5,65.5C 484.666,60.1563 484.499,54.8229 484,49.5C 481.385,46.9299 478.718,46.9299 476,49.5C 475.501,54.8229 475.334,60.1563 475.5,65.5C 473.833,65.5 472.167,65.5 470.5,65.5C 470.5,58.1667 470.5,50.8333 470.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#efefef",
    d: "M 563.5,42.5 C 571.821,42.8246 575.487,47.1579 574.5,55.5C 569.456,55.1725 564.456,55.5059 559.5,56.5C 560.128,58.2581 561.128,59.7581 562.5,61C 565.833,61.3333 569.167,61.6667 572.5,62C 573.833,63 573.833,64 572.5,65C 559.504,67.6691 554.004,62.5024 556,49.5C 557.767,46.228 560.267,43.8947 563.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e9e9e9",
    d: "M 272.5,43.5 C 274.167,43.5 275.833,43.5 277.5,43.5C 278.347,48.8879 279.513,54.2212 281,59.5C 282.206,54.4688 283.54,49.4688 285,44.5C 286.699,43.5939 288.533,43.2606 290.5,43.5C 291.22,48.3284 292.553,52.995 294.5,57.5C 295.821,53.2163 296.988,48.8829 298,44.5C 299.726,43.4238 301.559,43.2571 303.5,44C 301.246,50.8461 298.912,57.6794 296.5,64.5C 294.955,65.4519 293.288,65.7852 291.5,65.5C 291.099,60.5631 289.766,55.8964 287.5,51.5C 285.64,55.7454 283.973,60.0787 282.5,64.5C 280.994,65.7472 279.494,65.7472 278,64.5C 275.693,57.6039 273.86,50.6039 272.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f0f0f0",
    d: "M 253.5,42.5 C 264.331,43.1735 268.498,48.8402 266,59.5C 262.723,65.1088 257.89,66.9422 251.5,65C 245.01,59.9631 243.844,53.7964 248,46.5C 249.812,45.0229 251.645,43.6896 253.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0c0c0c",
    d: "M 569.5,49.5 C 568.486,50.7647 566.986,51.4313 565,51.5C 563.293,51.4915 561.793,51.1582 560.5,50.5C 560.884,47.9504 562.384,46.6171 565,46.5C 567.183,46.5221 568.683,47.5221 569.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0e0e",
    d: "M 253.5,46.5 C 261.121,46.9463 263.621,50.9463 261,58.5C 257.232,64.0363 253.899,63.703 251,57.5C 249.946,53.3445 250.78,49.6779 253.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0e0e",
    d: "M 357.5,46.5 C 364.382,46.8865 366.882,50.5532 365,57.5C 362.101,63.703 358.768,64.0363 355,58.5C 353.888,54.0186 354.721,50.0186 357.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a0a0a",
    d: "M 409.5,46.5 C 412.325,46.0807 414.491,47.0807 416,49.5C 416.667,52.8333 416.667,56.1667 416,59.5C 412.528,62.418 409.528,62.0846 407,58.5C 405.773,53.938 406.607,49.938 409.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#ededed",
    d: "M 449.5,42.5 C 460.342,42.527 464.842,47.8603 463,58.5C 459.677,64.9081 454.511,67.0748 447.5,65C 442.789,60.8604 441.289,55.6938 443,49.5C 444.694,46.6424 446.861,44.309 449.5,42.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0e0e0e",
    d: "M 450.5,46.5 C 457.07,47.2548 459.57,50.9214 458,57.5C 455.101,63.703 451.768,64.0363 448,58.5C 446.773,53.938 447.607,49.938 450.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#e0e0e0",
    d: "M 533.5,33.5 C 533.176,37.5546 533.509,41.5546 534.5,45.5C 535.107,45.3764 535.44,45.0431 535.5,44.5C 539.889,41.5516 543.722,42.2183 547,46.5C 548.416,52.7145 548.916,59.0478 548.5,65.5C 546.833,65.5 545.167,65.5 543.5,65.5C 543.666,60.1563 543.499,54.8229 543,49.5C 540.582,47.3199 537.916,46.9865 535,48.5C 534.501,54.1569 534.334,59.8236 534.5,65.5C 532.5,65.5 530.5,65.5 528.5,65.5C 528.5,54.8333 528.5,44.1667 528.5,33.5C 530.167,33.5 531.833,33.5 533.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#747474",
    d: "M 522.5,46.5 C 521.081,47.4511 519.415,47.7845 517.5,47.5C 517.5,51.5 517.5,55.5 517.5,59.5C 516.515,55.3656 516.182,51.0323 516.5,46.5C 518.5,46.5 520.5,46.5 522.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#b3b3b3",
    d: "M 323.5,50.5 C 324.486,54.97 324.819,59.6367 324.5,64.5C 325.833,64.5 327.167,64.5 328.5,64.5C 327.081,65.4511 325.415,65.7845 323.5,65.5C 323.5,60.5 323.5,55.5 323.5,50.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#919191",
    d: "M 569.5,49.5 C 570.404,50.209 570.737,51.209 570.5,52.5C 566.774,52.8226 563.107,52.4892 559.5,51.5C 559.624,50.8933 559.957,50.56 560.5,50.5C 561.793,51.1582 563.293,51.4915 565,51.5C 566.986,51.4313 568.486,50.7647 569.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5d5d5d",
    d: "M 509.5,43.5 C 509.5,44.5 509.5,45.5 509.5,46.5C 510.5,46.5 511.5,46.5 512.5,46.5C 512.5,51.1667 512.5,55.8333 512.5,60.5C 511.834,56.3155 511.167,51.9822 510.5,47.5C 508.984,48.8038 508.318,48.3038 508.5,46C 508.528,44.9302 508.861,44.0968 509.5,43.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#1a1a1a",
    d: "M 383.5,54.5 C 385.5,54.5 387.5,54.5 389.5,54.5C 389.875,60.3014 387.375,62.6347 382,61.5C 381.167,58.829 381.667,56.4957 383.5,54.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 95.5,60.5 C 98.8499,60.335 102.183,60.5017 105.5,61C 110.102,62.8064 114.769,64.3064 119.5,65.5C 124.705,64.7096 129.705,63.2096 134.5,61C 146.131,58.861 155.965,62.0277 164,70.5C 162.252,74.2826 159.586,77.6159 156,80.5C 148.63,96.8848 152.464,109.885 167.5,119.5C 163.521,130.642 157.187,140.142 148.5,148C 141.23,150.366 134.23,149.7 127.5,146C 123.5,145.333 119.5,145.333 115.5,146C 110.529,148.994 105.196,150.328 99.5,150C 97.5,149 95.5,148 93.5,147C 77.4685,130.425 70.3018,110.591 72,87.5C 74.7376,73.937 82.571,64.937 95.5,60.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#979797",
    d: "M 393.5,49.5 C 394.488,54.6405 394.821,59.9738 394.5,65.5C 392.114,65.7413 390.114,65.0746 388.5,63.5C 388.56,62.9569 388.893,62.6236 389.5,62.5C 390.524,63.8532 391.857,64.5198 393.5,64.5C 393.5,59.5 393.5,54.5 393.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 260.5,147.5 C 257.375,148.479 254.042,148.813 250.5,148.5C 248.833,143.167 247.167,137.833 245.5,132.5C 242.402,131.179 238.902,130.512 235,130.5C 231.317,130.501 227.817,130.835 224.5,131.5C 222.683,137.096 221.017,142.763 219.5,148.5C 216.232,149.487 212.898,149.82 209.5,149.5C 215.153,129.373 221.319,109.373 228,89.5C 230.041,88.2478 232.375,87.5812 235,87.5C 237.424,87.5296 239.757,87.8629 242,88.5C 248.08,108.237 254.247,127.904 260.5,147.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f6f6f6",
    d: "M 397.5,86.5 C 404.615,86.1744 411.615,86.8411 418.5,88.5C 418.101,91.6957 417.101,94.6957 415.5,97.5C 407.68,92.8658 400.514,93.5324 394,99.5C 392.798,103.793 393.965,107.293 397.5,110C 404.526,112.595 411.026,116.095 417,120.5C 422.478,129.906 421.311,138.406 413.5,146C 405.857,149.375 397.857,150.375 389.5,149C 382.307,148.418 380.64,145.085 384.5,139C 386.823,139.306 389.156,139.972 391.5,141C 395.5,141.667 399.5,141.667 403.5,141C 409.469,138.897 411.636,134.73 410,128.5C 408.5,127 407,125.5 405.5,124C 397.998,121.825 391.498,117.991 386,112.5C 380.839,99.8237 384.672,91.1571 397.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 433.5,139.5 C 433.5,130.167 433.5,120.833 433.5,111.5C 431.167,111.5 428.833,111.5 426.5,111.5C 426.5,109.167 426.5,106.833 426.5,104.5C 428.5,104.5 430.5,104.5 432.5,104.5C 432.336,101.813 432.503,99.146 433,96.5C 435.736,95.2728 438.569,94.2728 441.5,93.5C 442.489,97.1073 442.823,100.774 442.5,104.5C 446.167,104.5 449.833,104.5 453.5,104.5C 453.5,107.167 453.5,109.833 453.5,112.5C 449.833,112.5 446.167,112.5 442.5,112.5C 442.334,120.84 442.5,129.173 443,137.5C 443.465,138.931 444.299,140.097 445.5,141C 447.81,141.497 450.143,141.663 452.5,141.5C 452.5,144.167 452.5,146.833 452.5,149.5C 447.372,149.888 442.372,149.388 437.5,148C 435.218,145.603 433.884,142.769 433.5,139.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#121212",
    d: "M 234.5,96.5 C 237.616,105.282 240.282,114.282 242.5,123.5C 237.125,123.828 231.792,123.495 226.5,122.5C 229.545,113.931 232.212,105.264 234.5,96.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 279.5,166.5 C 276.5,166.5 273.5,166.5 270.5,166.5C 270.83,148.659 270.497,130.992 269.5,113.5C 269.5,110.5 269.5,107.5 269.5,104.5C 272.5,104.5 275.5,104.5 278.5,104.5C 278.337,106.857 278.503,109.19 279,111.5C 286.06,102.671 294.56,101.171 304.5,107C 314.18,118.49 315.013,130.657 307,143.5C 298.209,152.252 289.209,152.586 280,144.5C 279.5,151.826 279.334,159.159 279.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f8f8f8",
    d: "M 330.5,166.5 C 327.5,166.5 324.5,166.5 321.5,166.5C 321.5,145.833 321.5,125.167 321.5,104.5C 324.167,104.5 326.833,104.5 329.5,104.5C 328.582,112.102 329.916,112.935 333.5,107C 351.418,100.131 361.418,106.298 363.5,125.5C 363.155,143.696 354.155,151.529 336.5,149C 334.376,147.878 332.543,146.378 331,144.5C 330.5,151.826 330.334,159.159 330.5,166.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 475.5,103.5 C 497.636,103.814 506.136,114.814 501,136.5C 495.038,148.171 485.538,152.338 472.5,149C 466.18,146.014 462.013,141.181 460,134.5C 456.739,119.687 461.906,109.353 475.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#fcfcfc",
    d: "M 534.5,103.5 C 534.5,106.5 534.5,109.5 534.5,112.5C 532.585,112.216 530.919,112.549 529.5,113.5C 524.753,114.584 522.086,117.584 521.5,122.5C 520.507,130.984 520.174,139.651 520.5,148.5C 517.5,148.5 514.5,148.5 511.5,148.5C 511.5,133.833 511.5,119.167 511.5,104.5C 514.167,104.5 516.833,104.5 519.5,104.5C 519.336,107.187 519.503,109.854 520,112.5C 522.924,106.407 527.757,103.407 534.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#f7f7f7",
    d: "M 578.5,119.5 C 578.5,122.5 578.5,125.5 578.5,128.5C 568.652,128.173 558.986,128.506 549.5,129.5C 549.557,135.732 552.557,139.898 558.5,142C 564.275,142.689 569.942,142.189 575.5,140.5C 577.812,145.711 576.146,148.545 570.5,149C 548.03,152.527 537.863,143.027 540,120.5C 545.233,105.3 555.4,100.467 570.5,106C 574.86,109.561 577.526,114.061 578.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#4d4d4d",
    d: "M 534.5,103.5 C 535.479,106.625 535.813,109.958 535.5,113.5C 533.5,113.5 531.5,113.5 529.5,113.5C 530.919,112.549 532.585,112.216 534.5,112.5C 534.5,109.5 534.5,106.5 534.5,103.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070707",
    d: "M 475.5,111.5 C 484.149,109.65 489.649,112.983 492,121.5C 493.162,127.557 492.162,133.223 489,138.5C 479.966,145.152 473.632,143.152 470,132.5C 467.978,124.351 469.811,117.351 475.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#070707",
    d: "M 569.5,121.5 C 562.646,121.824 555.979,121.491 549.5,120.5C 552.306,110.512 558.139,108.179 567,113.5C 568.707,115.909 569.54,118.575 569.5,121.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#090909",
    d: "M 287.5,111.5 C 297.608,111.443 302.608,116.61 302.5,127C 301.984,131.549 300.484,135.715 298,139.5C 290.109,144.523 284.109,142.857 280,134.5C 278.644,127.388 279.644,120.721 283,114.5C 284.652,113.601 286.152,112.601 287.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#0a0a0a",
    d: "M 338.5,111.5 C 348.656,111.491 353.656,116.658 353.5,127C 353.662,135.552 349.662,140.718 341.5,142.5C 335.538,141.704 332.038,138.37 331,132.5C 328.493,123.547 330.993,116.547 338.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#969696",
    d: "M 426.5,111.5 C 428.833,111.5 431.167,111.5 433.5,111.5C 433.5,120.833 433.5,130.167 433.5,139.5C 432.507,130.682 432.173,121.682 432.5,112.5C 430.265,112.795 428.265,112.461 426.5,111.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#cccccc",
    d: "M 269.5,113.5 C 270.497,130.992 270.83,148.659 270.5,166.5C 273.5,166.5 276.5,166.5 279.5,166.5C 276.375,167.479 273.042,167.813 269.5,167.5C 269.5,149.5 269.5,131.5 269.5,113.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a3a3a3",
    d: "M 321.5,104.5 C 321.5,125.167 321.5,145.833 321.5,166.5C 324.5,166.5 327.5,166.5 330.5,166.5C 327.375,167.479 324.042,167.813 320.5,167.5C 320.169,146.327 320.503,125.327 321.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#5f5f5f",
    d: "M 549.5,120.5 C 555.979,121.491 562.646,121.824 569.5,121.5C 562.656,122.819 555.656,122.819 548.5,121.5C 548.624,120.893 548.957,120.56 549.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#a5a5a5",
    d: "M 521.5,122.5 C 521.5,131.5 521.5,140.5 521.5,149.5C 517.958,149.813 514.625,149.479 511.5,148.5C 514.5,148.5 517.5,148.5 520.5,148.5C 520.174,139.651 520.507,130.984 521.5,122.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#aeaeae",
    d: "M 578.5,119.5 C 579.479,122.625 579.813,125.958 579.5,129.5C 569.5,129.5 559.5,129.5 549.5,129.5C 558.986,128.506 568.652,128.173 578.5,128.5C 578.5,125.5 578.5,122.5 578.5,119.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#707070",
    d: "M 224.5,131.5 C 227.817,130.835 231.317,130.501 235,130.5C 238.902,130.512 242.402,131.179 245.5,132.5C 238.588,131.538 231.588,131.205 224.5,131.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#878787",
    d: "M 260.5,147.5 C 261.043,147.56 261.376,147.893 261.5,148.5C 257.685,149.808 254.019,149.808 250.5,148.5C 254.042,148.813 257.375,148.479 260.5,147.5 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlay);
export default __webpack_public_path__ + "static/media/google-play.6790460b7083fdef934eecf3282a0aae.svg";
export { ForwardRef as ReactComponent };